import { Paper, Typography, Box } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList,
} from 'recharts';
import { formatMoney } from '../utils';

const PAID_COLOR = '#1565c0';
const ORGANIC_COLOR = '#43a047';

const SourceRevenueChart = ({ sources }) => {
  const sorted = sources
    .filter((s) => s.totalRevenue > 0)
    .sort((a, b) => b.totalRevenue - a.totalRevenue)
    .slice(0, 15);

  const chartHeight = Math.max(280, sorted.length * 48 + 60);

  return (
    <Paper sx={{ p: 2.5, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#0d3c61' }}>Revenue by Source</Typography>
        <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: PAID_COLOR }} />
            <Typography variant="caption" color="text.secondary">Paid</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 12, height: 12, borderRadius: 1, bgcolor: ORGANIC_COLOR }} />
            <Typography variant="caption" color="text.secondary">Organic</Typography>
          </Box>
        </Box>
      </Box>
      {sorted.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 6 }}>
          No revenue data
        </Typography>
      ) : (
        <ResponsiveContainer width="100%" height={chartHeight}>
          <BarChart data={sorted} layout="vertical" margin={{ left: 20, right: 80, top: 5, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" tickFormatter={(v) => `$${(v / 1000).toFixed(0)}k`} fontSize={11} />
            <YAxis type="category" dataKey="sourceName" width={140} fontSize={11} tick={{ fontWeight: 500 }} />
            <Tooltip
              formatter={(v) => formatMoney(v)}
              labelFormatter={(label) => label}
              contentStyle={{ fontSize: 12 }}
            />
            <Bar dataKey="totalRevenue" name="Revenue" radius={[0, 4, 4, 0]} barSize={26}>
              {sorted.map((entry, i) => (
                <Cell key={i} fill={entry.sourceType === 'paid' ? PAID_COLOR : ORGANIC_COLOR} fillOpacity={i === 0 ? 1 : 0.85} />
              ))}
              <LabelList dataKey="totalRevenue" position="right" formatter={formatMoney} style={{ fontWeight: 700, fontSize: 11, fill: '#333' }} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default SourceRevenueChart;
